import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useHomeLinkClick from '../custom-hooks/useHomeLinkClick.js';
import { NAV_LINKS } from '../siteConfig.js';


function NavBar() {

  const [isNavOpen, setIsNavOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const handleHomeClick = useHomeLinkClick(() => setIsNavOpen(false));

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setHasScrolled(true);
      } else {
        setHasScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`flex-no-wrap fixed top-0 z-10 flex w-full items-center justify-center transition-all duration-700 ${
      isHomePage 
        ? hasScrolled ? 'bg-dj-dark shadow-lg shadow-black/20' : 'bg-transparent shadow-md shadow-black/5'
        : 'bg-dj-dark shadow-lg shadow-black/20'
    }`} style={{ borderTop: isHomePage && !hasScrolled ? '2px solid rgba(247, 36, 68, 1)' : '0px solid rgba(247, 36, 68, 0)' }}>
      <div className="flex w-full max-w-[2000px] items-center justify-between px-4 md:px-20 py-4 md:py-6">
        <a href="/">
          <h1 className="font-bold text-left text-primary">
            Derek Johnston<span className="font-normal text-left text-secondary"> | </span><span className="font-normal text-left text-white"> Design Strategist</span>
          </h1>
        </a>
        <nav>
        <section className="MOBILE-MENU flex lg:hidden">
          <div
            className="HAMBURGER-ICON space-y-2"
            onClick={() => setIsNavOpen((prev) => !prev)}
          >
            <span className="block h-0.5 w-8 bg-white"></span>
            <span className="block h-0.5 w-8 bg-white"></span>
            <span className="block h-0.5 w-8 bg-white"></span>
          </div>

          <div className={isNavOpen ? "showMenuNav" : "hideMenuNav"}>
            <div
              className="CROSS-ICON absolute top-0 right-0 px-8 py-8"
              onClick={() => setIsNavOpen(false)}
            >
              <svg
                className="h-8 w-8 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>
            <ul className="NAVIGATION-MOBILE-OPEN flex flex-col items-center justify-between min-h-[250px] text-white">
              {NAV_LINKS.map((link) => (
                <li key={link.label} className="border-b border-gray-400 my-8 uppercase">
                  {link.isRoute ? (
                    <Link to={link.href} onClick={handleHomeClick}>{link.label}</Link>
                  ) : (
                    <a href={link.href} onClick={() => setIsNavOpen(false)}>{link.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <ul className="DESKTOP-MENU hidden space-x-8 lg:flex text-white">
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              {link.isRoute ? (
                <Link to={link.href} onClick={handleHomeClick} className="hover:text-primary border-b-2 border-transparent hover:border-secondary pb-1 transition-all">{link.label}</Link>
              ) : (
                <a href={link.href} className="hover:text-primary border-b-2 border-transparent hover:border-secondary pb-1 transition-all">{link.label}</a>
              )}
            </li>
          ))}
        </ul>
      </nav>
      </div>
    </div>
  );
}

export default NavBar;